import defaultSkin from "../img/steve-face.png"
import facebook from "../img/Facebook_Logo_Primary.png"
import youtube from "../img/yt_icon_rgb.png"
import twitch from "../img/glitch_flat_purple.png"
import x from "../img/x-logo-white.png"
import discord from "../img/icon_clyde_blurple_RGB.png"

// Used to map Social Media Images to a value to make it easily searchable
let socials = {
    "facebook": facebook,
    "youtube": youtube,
    "twitch": twitch,
    "x": x,
    "discord": discord
}

// Returns Default Skin
function getDefaultSkin() {
    return defaultSkin;
}

// Returns Social Media Image based on supplied social media
function getSocialMediaLogo(socialMedia) {
    return socials[socialMedia];
}


export {getDefaultSkin, getSocialMediaLogo};